import Globalize from '../actions/languages/Globalize';

// Menu items mapping with all properties
// export const MENU_ITEMS = [
//   {
//     id: 'suppliers',
//     role: 'suppliers_view',
//     path: '/suppliers',
//     icon: 'fa fa-building-o fa-fw',
//     label: 'suppliers',
//     version: 'v1',
//     type: 'internal',
//   },
//   {
//     id: 'catalogs',
//     role: 'catalogs_view',
//     path: '/v3/cataloging/catalogs',
//     icon: 'fa fa-database fa-fw',
//     label: 'catalogs',
//     version: 'v3',
//     type: 'external',
//   },
//   {
//     id: 'collections',
//     role: 'collections_view',
//     path: '/collections',
//     icon: 'fa fa-database fa-fw',
//     label: 'collections',
//     version: 'v1',
//     type: 'internal'
//   },
//   {
//     id: 'hvf_admin',
//     role: 'hvf_admin',
//     path: '/hvf-admin',
//     icon: 'fa fa-filter fa-fw',
//     label: 'hvf_admin',
//     version: 'v1',
//     type: 'internal'
//   },
//   // {
//   //   id: 'community_moderation',
//   //   role: 'community_moderation',
//   //   path: '/community/moderation',
//   //   icon: 'fa fa-file fa-fw',
//   //   label: 'community_moderation',
//   //   version: 'v1',
//   //   type: 'internal'
//   // },
//   // {
//   //   id: 'community_upload',
//   //   role: 'community_upload',
//   //   path: '/community/upload',
//   //   icon: 'fa fa-upload',
//   //   label: 'community_upload',
//   //   version: 'v1',
//   //   type: 'internal'
//   // },
//   {
//     id: 'widget_group',
//     role: 'widgets_view',
//     path: '/widgets-group',
//     icon: 'fa fa-list fa-fw',
//     label: 'widget_group',
//     version: 'v1',
//     type: 'internal'
//   },
//   {
//     id: 'landing_pages',
//     role: 'landing_pages_view',
//     path: '/landing-pages',
//     icon: 'fa fa-list fa-fw',
//     label: 'landing_pages',
//     version: 'v1',
//     type: 'internal'
//   },
//   {
//     id: 'orders',
//     role: 'orders_view',
//     path: '/orders',
//     icon: 'fa fa-shopping-cart fa-fw',
//     label: 'orders',
//     version: 'v1',
//     type: 'internal'
//   },
//   {
//     id: 'reseller',
//     role: 'resellers_view',
//     path: '/v3/reseller',
//     icon: 'fa fa-building-o fa-fw',
//     label: 'reseller',
//     version: 'v3',
//     type: 'external'
//   },
//   {
//     id: 'supplier_payment',
//     role: 'supplier_payments_view',
//     path: '/supplier/payment',
//     icon: 'fa fa-building-o fa-fw',
//     label: 'supplier_payment',
//     version: 'v1',
//     type: 'internal'
//   },
//   {
//     id: 'app_banners',
//     role: 'app_banners_view',
//     path: '/app-banners',
//     icon: 'fa fa-image fa-fw',
//     label: 'app_banners',
//     version: 'v1',
//     type: 'internal'
//   },
//   // {
//   //   id: 'cod_verification',
//   //   role: 'cod_verification_view',
//   //   path: '/codverification',
//   //   icon: 'fa fa-file-excel-o fa-fw',
//   //   label: 'cod_verification',
//   //   version: 'v1',
//   //   type: 'internal'
//   // },
//   // {
//   //   id: 'daily_trends',
//   //   role: 'trends_view',
//   //   path: '/dailytrends',
//   //   icon: 'fa fa-file-excel-o fa-fw',
//   //   label: 'daily_trends',
//   //   version: 'v1',
//   //   type: 'internal'
//   // },
//   // {
//   //   id: 'bulk_cancellation',
//   //   role: 'bulk_cancellations_view',
//   //   path: '/bulkcancellation',
//   //   icon: 'fa fa-file-excel-o fa-fw',
//   //   label: 'bulk_cancellation',
//   //   version: 'v1',
//   //   type: 'internal'
//   // },
//   {
//     id: 'firebase_admin',
//     role: 'firebase_admin',
//     path: '/firebase/admin',
//     icon: 'fa fa-user-circle-o',
//     label: 'firebase_admin',
//     version: 'v1',
//     type: 'internal'
//   },
//   {
//     id: 'tax_invoices',
//     role: 'supplier_invoice',
//     path: '/tax-invoices',
//     icon: 'fa fa-file-excel-o fa-fw',
//     label: 'tax_invoices',
//     version: 'v1',
//     type: 'internal'
//   },
//   // {
//   //   id: 'supplier_penalty',
//   //   role: 'supplier_penalty',
//   //   path: '/supplier-penalty-old',
//   //   icon: 'fa fa-file-excel-o fa-fw',
//   //   label: 'supplier_penalty',
//   //   version: 'v1',
//   //   type: 'internal'
//   // },
//   {
//     id: 'supply_tasks',
//     role: 'supply_tasks',
//     path: '/supply-tasks',
//     icon: 'fa fa-file-excel-o fa-fw',
//     label: 'supply_tasks',
//     version: 'v1',
//     type: 'internal'
//   },
//   {
//     id: 'admin_access',
//     role: 'user_access_admin',
//     path: '/admin-access',
//     icon: 'fa fa-file-excel-o fa-fw',
//     label: 'admin_access',
//     version: 'v1',
//     type: 'internal'
//   },
//   {
//     id: 'admin_notices',
//     role: 'admin_notice',
//     path: '/admin-notices',
//     icon: 'fa fa-file-excel-o fa-fw',
//     label: 'admin_notices',
//     version: 'v1',
//     type: 'internal'
//   },
//   {
//     id: 'review_ratings',
//     role: 'catalog_rating_review',
//     path: '/review-ratings',
//     icon: 'fa fa-image fa-fw',
//     label: 'review_ratings',
//     version: 'v1',
//     type: 'internal'
//   },
//   // {
//   //   id: 'video_influencer',
//   //   role: 'video_influencer_review',
//   //   path: '/video-influencer',
//   //   icon: 'fa fa-image fa-fw',
//   //   label: 'video_influencer',
//   //   version: 'v1',
//   //   type: 'internal'
//   // },
//   {
//     id: 'dynamic_webview',
//     role: 'dynamic_webview',
//     path: '/dynamic-webview',
//     icon: 'fa fa-image fa-fw',
//     label: 'dynamic_webview',
//     version: 'v1',
//     type: 'internal'
//   },
//   // {
//   //   id: 'tinder_ratings',
//   //   role: 'catalog_rating_file_upload',
//   //   path: '/catalog-rating-rewards',
//   //   icon: 'fa fa-file-excel-o fa-fw',
//   //   label: 'tinder_ratings',
//   //   version: 'v1',
//   //   type: 'internal'
//   // },
//   // {
//   //   id: 'meesho_rewards',
//   //   role: 'meesho_reseller_rewards',
//   //   path: '/meesho-rewards',
//   //   icon: 'fa fa-file-excel-o fa-fw',
//   //   label: 'meesho_rewards',
//   //   version: 'v1',
//   //   type: 'internal'
//   // },
//   // {
//   //   id: 'mentor_dashboard',
//   //   role: 'mentor_performance_dashboard',
//   //   path: '/mentor-dashboard',
//   //   icon: 'fa fa-file-excel-o fa-fw',
//   //   label: 'mentor_dashboard',
//   //   version: 'v1',
//   //   type: 'internal'
//   // },
//   // {
//   //   id: 'supplier_manifest',
//   //   role: 'supplier_manifest',
//   //   path: '/supplier-manifest',
//   //   icon: 'fa fa-file-excel-o fa-fw',
//   //   label: 'supplier_manifest',
//   //   version: 'v1',
//   //   type: 'internal'
//   // },
//   {
//     id: 'files_uploading',
//     role: 'files_uploading',
//     path: '/files-uploading',
//     icon: 'fa fa-file-excel-o fa-fw',
//     label: 'files_uploading',
//     version: 'v1',
//     type: 'internal'
//   },
//   {
//     id: 'visual_search',
//     role: 'visual_search',
//     path: '/v3/discovery/visual-search',
//     icon: 'fa fa-file-excel-o fa-fw',
//     label: 'visual_search',
//     version: 'v3',
//     type: 'external'
//   },
//   {
//     id: 'update_pow_static_assets',
//     role: 'update_pow_static_assets',
//     path: '/v3/discovery/update-static-assets',
//     icon: 'fa fa-file-excel-o fa-fw',
//     label: 'update_pow_static_assets',
//     version: 'v3',
//     type: 'external'
//   },
//   {
//     id: 'marketing_dashboard',
//     role: 'marketing_dashboard',
//     path: '/marketing-dashboard',
//     icon: 'fa fa-file-excel-o fa-fw',
//     label: 'marketing_dashboard',
//     version: 'v1',
//     type: 'internal'
//   },
//   {
//     id: 'ab_experiment',
//     role: 'ab_experiment',
//     path: '/ab-experiment',
//     icon: 'fa fa-rupee fa-fw',
//     label: 'ab_experiment',
//     version: 'v1',
//     type: 'internal'
//   },
//   {
//     id: 'abacus',
//     role: 'abacus',
//     path: '/v3/discovery/abacus',
//     icon: 'fa fa-rupee fa-fw',
//     label: 'abacus',
//     version: 'v3',
//     type: 'external'
//   },
//   {
//     id: 'audience_system',
//     role: 'audience_system',
//     path: '/audience-system',
//     icon: 'fa fa-user-circle-o',
//     label: 'audience_system',
//     version: 'v1',
//     type: 'internal'
//   },
//   // {
//   //   id: 'deals',
//   //   role: 'pricing_deals',
//   //   path: '/deals',
//   //   icon: 'fa fa-user-circle-o',
//   //   label: 'deals',
//   //   version: 'v1',
//   //   type: 'internal'
//   // },
//   // {
//   //   id: 'price_scheduling',
//   //   role: 'price_scheduling',
//   //   path: '/price-scheduling',
//   //   icon: 'fa fa-user-circle-o',
//   //   label: 'price_scheduling',
//   //   version: 'v1',
//   //   type: 'internal'
//   // },
//   {
//     id: 'sms_portal',
//     role: 'sms_portal_view',
//     path: '/v3/comms/sms',
//     icon: 'fa fa-database fa-fw',
//     label: 'sms_portal',
//     version: 'v3',
//     type: 'external'
//   },
//   {
//     id: 'notification_portal',
//     role: 'notification_portal_view',
//     path: '/v3/comms/notification',
//     icon: 'fa fa-database fa-fw',
//     label: 'notification_portal',
//     version: 'v3',
//     type: 'external'
//   },
//   {
//     id: 'whatsapp_notification',
//     role: 'whatsapp_notifications_view',
//     path: '/v3/comms/whatsapp',
//     icon: 'fa fa-database fa-fw',
//     label: 'whatsapp_notification',
//     version: 'v3',
//     type: 'external'
//   },
//   {
//     id: 'email_notifications',
//     role: 'email_notifications',
//     path: '/v2/email-notifications',
//     icon: 'fa fa-database fa-fw',
//     label: 'email_notifications',
//     version: 'v2',
//     type: 'external'
//   },
//   {
//     id: 'all_notification_campaigns',
//     role: 'notification_all_campaigns',
//     path: '/v3/comms/all-notifications',
//     icon: 'fa fa-database fa-fw',
//     label: 'all_notification_campaigns',
//     version: 'v3',
//     type: 'external'
//   },
//   {
//     id: 'make_calls',
//     role: 'make_calls_view',
//     path: '/make-calls',
//     icon: 'fa fa-database fa-fw',
//     label: 'make_calls',
//     version: 'v1',
//     type: 'internal'
//   },
//   // {
//   //   id: 'gamification',
//   //   role: 'gamification',
//   //   path: '/gamification',
//   //   icon: 'fa fa-user-circle-o',
//   //   label: 'gamification',
//   //   version: 'v1',
//   //   type: 'internal'
//   // },
//   // {
//   //   id: 'referral_campaign',
//   //   role: 'referral_campaign',
//   //   path: '/referral_campaign',
//   //   icon: 'fa fa-user-circle-o',
//   //   label: 'Referral Campaign',
//   //   version: 'v1',
//   //   type: 'internal'
//   // },
//   // {
//   //   id: 'referral_program',
//   //   role: 'referral_program',
//   //   path: '/referral_program',
//   //   icon: 'fa fa-file-excel-o fa-fw',
//   //   label: 'referral_program',
//   //   version: 'v1',
//   //   type: 'internal'
//   // },
//   {
//     id: 's3_file_uploader',
//     role: 's3_file_uploader',
//     path: '/s3-file-uploader',
//     icon: 'fa fa-user-circle-o',
//     label: 's3_file_uploader',
//     version: 'v1',
//     type: 'internal'
//   },
//   {
//     id: 'excel_upload',
//     role: 'generic_excel_upload',
//     path: '/excel-upload',
//     icon: 'fa fa-file-excel-o fa-fw',
//     label: 'excel_upload',
//     version: 'v1',
//     type: 'internal'
//   },
//   {
//     id: 'rule_engine',
//     role: 'rule_engine',
//     path: '/rule-engine',
//     icon: 'fa fa-file-excel-o fa-fw',
//     label: 'rule_engine',
//     version: 'v1',
//     type: 'internal'
//   },
//   {
//     id: 'search_ops',
//     role: 'search_ops',
//     path: '/v3/discovery/search-ops',
//     icon: 'fa fa-search fa-fw',
//     label: 'search_ops',
//     version: 'v3',
//     type: 'external'
//   },
//   {
//     id: 'category_navigation_trees',
//     role: 'category_navigation_trees',
//     path: '/category-navigation',
//     icon: 'fa fa-file-excel-o fa-fw',
//     label: 'category_navigation_trees',
//     version: 'v1',
//     type: 'internal'
//   },
//   {
//     id: 'clp_admin',
//     role: 'clp_admin',
//     path: '/clp-admin',
//     icon: 'fa fa-file-excel-o fa-fw',
//     label: 'clp_admin',
//     version: 'v1',
//     type: 'internal'
//   },
//   {
//     id: 'top_nav_admin',
//     role: 'top_nav_admin',
//     path: '/top-nav-admin',
//     icon: 'fa fa-file-excel-o fa-fw',
//     label: 'top_nav_admin',
//     version: 'v1',
//     type: 'internal'
//   },
//   {
//     id: 'sort_and_filter',
//     role: 'sort_and_filter',
//     path: '/sort-and-filter',
//     icon: 'fa fa-file-excel-o fa-fw',
//     label: 'sort_and_filter',
//     version: 'v1',
//     type: 'internal'
//   },
//   {
//     id: 'clp_products_view',
//     role: 'clp_products_view',
//     path: '/clp/products',
//     icon: 'fa fa-file-excel-o fa-fw',
//     label: 'CLP Filters Validation',
//     version: 'v1',
//     type: 'internal'
//   },
//   // {
//   //   id: 'agent_dashboard',
//   //   role: 'agent_dashboard',
//   //   path: '/agent-dashboard/search',
//   //   icon: 'fa fa-file-excel-o fa-fw',
//   //   label: 'agent_dashboard',
//   //   version: 'v1',
//   //   type: 'internal'
//   // },
//   // {
//   //   id: 'uat_catalogs',
//   //   role: 'uat_catalogs',
//   //   path: '/supply-tasks/uat-catalogs',
//   //   icon: 'fa fa-file-excel-o fa-fw',
//   //   label: 'uat_catalogs',
//   //   version: 'v1',
//   //   type: 'internal'
//   // },
//   // {
//   //   id: 'supplier_finance',
//   //   role: 'supplier_finance',
//   //   path: '/verify-kyc',
//   //   icon: 'fa fa-database fa-fw',
//   //   label: 'supplier_finance',
//   //   version: 'v1',
//   //   type: 'internal'
//   // },
//   {
//     id: 'return_reasons',
//     role: 'return_reasons',
//     path: '/fulfilment',
//     icon: 'fa fa-database fa-fw',
//     label: 'return_reasons',
//     version: 'v1',
//     type: 'internal'
//   },
//   {
//     id: 'legal_and_policies',
//     role: 'legal_and_policies',
//     path: '/legal-and-policies',
//     icon: 'fa fa-database fa-fw',
//     label: 'Legal and Policies',
//     version: 'v1',
//     type: 'internal'
//   },
//   {
//     id: 'ads_task',
//     role: 'supplier_ads_task',
//     path: '/ads-task',
//     icon: 'fa fa-database fa-fw',
//     label: 'Ads Task',
//     version: 'v1',
//     type: 'internal'
//   },
//   {
//     id: 'mma_task',
//     role: 'supplier_ads_task_mma_deep_link',
//     path: '/mma-task',
//     icon: 'fa fa-database fa-fw',
//     label: 'MMA task',
//     version: 'v1',
//     type: 'internal'
//   },
//   {
//     id: 'live_commerce',
//     role: 'live_stream_view',
//     path: '/live-commerce',
//     icon: 'fa fa-database fa-fw',
//     label: 'live_commerce',
//     version: 'v1',
//     type: 'internal'
//   },
//   {
//     id: 'pow',
//     role: 'pow',
//     path: '/pow',
//     icon: 'fa fa-database fa-fw',
//     label: 'POW',
//     version: 'v1',
//     type: 'internal'
//   },
//   {
//     id: 'display_ads',
//     role: 'dispaly_ads_section',
//     path: '/campaign-dashboard',
//     icon: 'fa fa-database fa-fw',
//     label: 'Display Ads',
//     version: 'v1',
//     type: 'internal'
//   },
//   {
//     id: 'non_seller_portal',
//     role: 'dispaly_ads_section',
//     path: '/non-seller-portal',
//     icon: 'fa fa-database fa-fw',
//     label: 'Non Seller Portal',
//     version: 'v1',
//     type: 'internal'
//   },
//   {
//     id: 'promotions',
//     role: 'promotions_view',
//     path: '/v3/promotions',
//     icon: 'fa fa-percent fa-fw',
//     label: 'promotions',
//     version: 'v3',
//     type: 'external'
//   },
//   {
//     id: 'agency_panel_account_management',
//     role: 'agency_panel_account_management',
//     path: '/v2/agency-account-management',
//     icon: 'fa fa-database fa-fw',
//     label: 'agency_panel_account_management',
//     version: 'v2',
//     type: 'external'
//   },
//   {
//     id: 'admin_queries',
//     role: 'admin_queries',
//     path: '/v2/admin-queries',
//     icon: 'fa fa-database fa-fw',
//     label: 'admin_queries',
//     version: 'v2',
//     type: 'external'
//   },
//   {
//     id: 'agent_queries',
//     role: 'agent_queries',
//     path: '/v2/agent-queries',
//     icon: 'fa fa-database fa-fw',
//     label: 'agent_queries',
//     version: 'v2',
//     type: 'external'
//   },
//   {
//     id: 'ds_tagging',
//     role: 'ds_tagging',
//     path: '/v2/ds-tagging',
//     icon: 'fa fa-database fa-fw',
//     label: 'ds_tagging',
//     version: 'v2',
//     type: 'external'
//   },
//   {
//     id: 'bulk_password_reset',
//     role: 'bulk_password_reset',
//     path: '/v2/password-reset-bulk',
//     icon: 'fa fa-database fa-fw',
//     label: 'bulk_password_reset',
//     version: 'v2',
//     type: 'external'
//   },
//   {
//     id: 'bulk_gstin_invalidate',
//     role: 'bulk_gstin_invalidate',
//     path: '/v2/gstin-invalidate-bulk',
//     icon: 'fa fa-database fa-fw',
//     label: 'bulk_gstin_invalidate',
//     version: 'v2',
//     type: 'external'
//   },
//   {
//     id: 'supplier_role_based_access',
//     role: 'supplier_panel_access_control',
//     path: '/v3/cataloging/role-based-access',
//     icon: 'fa fa-database fa-fw',
//     label: 'supplier_role_based_access',
//     version: 'v3',
//     type: 'external'
//   },
//   {
//     id: 'send_supplier_email',
//     role: 'send_supplier_email',
//     path: '/v3/cataloging/supplier-email',
//     icon: 'fa fa-database fa-fw',
//     label: 'send_supplier_email',
//     version: 'v3',
//     type: 'external'
//   },
//   {
//     id: 'zero_order_audience',
//     role: 'zero_order_audience',
//     path: '/v3/discovery/zero-order-audience',
//     icon: 'fa fa-users fa-fw',
//     label: 'zero_order_audience',
//     version: 'v3',
//     type: 'external'
//   },
//   {
//     id: 'single_product_details',
//     role: 'single_product_details_admin',
//     path: '/v3/discovery/single-product-details',
//     icon: 'fa fa-product-hunt fa-fw',
//     label: 'single_product_details',
//     version: 'v3',
//     type: 'external'
//   },
//   {
//     id: 'debug_your_widget_group',
//     role: 'widgets_view',
//     path: '/v3/discovery/debug-your-widget-group',
//     icon: 'fa fa-users fa-fw',
//     label: 'debug_your_widget_group',
//     version: 'v3',
//     type: 'external'
//   },
//   {
//     id: 'meesho_reels',
//     role: 'reel_moderation_dashboard',
//     path: '/v3/comms/meesho-reels',
//     icon: 'fa fa-users fa-fw',
//     label: 'meesho_reels',
//     version: 'v3',
//     type: 'external'
//   },
//   {
//     id: 'seller_bank_verification',
//     role: 'seller_bank_verification_request_view',
//     path: '/v3/cataloging/seller-bank-verification',
//     icon: 'fa fa-database fa-fw',
//     label: 'seller_bank_verification',
//     version: 'v3',
//     type: 'external'
//   },
//   {
//     id: 'sdui_widget_forge',
//     role: 'widgets_view',
//     path: '/v3/discovery/widget-forge',
//     icon: 'fa fa-gear fa-fw',
//     label: 'sdui_widget_forge',
//     version: 'v3',
//     type: 'external'
//   },
//   {
//     id: 'sdui_widget_preview',
//     role: 'widgets_view',
//     path: '/v3/discovery/sdui/widget-preview',
//     icon: 'fa fa-camera-retro fa-fw',
//     label: 'sdui_widget_preview',
//     version: 'v3',
//     type: 'external'
//   },
//   {
//     id: 'sdui_widget_template',
//     role: 'sdui_widget_template',
//     path: '/v3/discovery/sdui/templates',
//     icon: 'fa fa-database fa-fw',
//     label: 'sdui_widget_template',
//     version: 'v3',
//     type: 'external'
//   },
//   {
//     id: 'plp_management_tool',
//     role: 'pow_products_file_upload',
//     path: '/v3/comms/plp-management',
//     icon: 'fa fa-gear fa-fw',
//     label: 'plp_management_tool',
//     version: 'v3',
//     type: 'external'
//   },
//   {
//     id: 'homepage_content_update',
//     role: 'pow_dweb_hp_widgets',
//     path: '/v3/comms/pow-dweb-homepage-content-update',
//     icon: 'fa fa-gear fa-fw',
//     label: 'homepage_content_update',
//     version: 'v3',
//     type: 'external'
//   },
//   {
//     id: 'mcc_config',
//     role: 'content_creator_config',
//     path: '/v3/discovery/mcc-config',
//     icon: 'fa fa-bell fa-fw',
//     label: 'mcc_config',
//     version: 'v3',
//     type: 'external'
//   },
//   {
//     id: 'seller_policy',
//     role: 'supplier_policies_view',
//     path: '/v3/container/seller-policy',
//     icon: 'fa fa-file-text-o fa-fw',
//     label: 'seller_policy',
//     version: 'v3',
//     type: 'external'
//   },
//   {
//     id: 'audit_platform',
//     role: 'fne_audit_platform',
//     path: '/v3/experience/audit-platform',
//     icon: 'fa fa-file-text-o fa-fw',
//     label: 'audit_platform',
//     version: 'v3',
//     type: 'external'
//   }
// ];

// Helper function to get version counts
export const getVersionCounts = (features = []) => {
  const counts = { v1: 0, v2: 0, v3: 0, all: 0 };

  features?.forEach((item) => {
    if (item?.route?.includes('/v2/')) {
      counts.v2++;
    } else if (item?.route?.includes('/v3/')) {
      counts.v3++;
    } else {
      counts.v1++;
    }
    counts.all++;
  });

  return counts;
};